import { Command } from 'ckeditor5/src/core';

export default class MediaBrowserVideoCommand extends Command {
	/** Configuration setting name. */
	get configName() { return 'mediaBrowserVideo'; }

	execute(source) {
		const selection = this.editor.model.document.selection;

		this.editor.model.change((writer) => {
            this.editor.model.insertContent(createVideoElement(writer, selection, source));
        });
	}
}

function createVideoElement(writer, selection, source) {
	const element = writer.createElement('video', {
		...Object.fromEntries(selection.getAttributes()),
		'data-source': source
	});
	return element;
}
